function ClippedSquareBorder() {
  return (
    <svg
      width={285}
      height={100}
      viewBox="0 0 285 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="path-1-inside-1_137_2411" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 46.4283V100H285V0H49.2709L0 46.4283Z"
        />
      </mask>
      <path
        d="M0 100H-1V101H0V100ZM0 46.4283L-0.685801 45.7005L-1 45.9966V46.4283H0ZM285 100V101H286V100H285ZM285 0H286V-1H285V0ZM49.2709 0V-1H48.874L48.5851 -0.727789L49.2709 0ZM1 100V46.4283H-1V100H1ZM285 99H0V101H285V99ZM284 0V100H286V0H284ZM49.2709 1H285V-1H49.2709V1ZM48.5851 -0.727789L-0.685801 45.7005L0.685801 47.1561L49.9567 0.727789L48.5851 -0.727789Z"
        fill="#22222F"
        mask="url(#path-1-inside-1_137_2411)"
      />
    </svg>

  );
}

export default ClippedSquareBorder;